import api from './client'

// FINANZAS → Conciliación de tarjetas Payway ↔ Presea (Martin, 28 sep 2026).
const base = '/conciliaciones-tarjeta'

async function bajar(url, nombre) {
  const { data } = await api.get(url, { responseType: 'blob' })
  const href = URL.createObjectURL(data)
  const a = document.createElement('a')
  a.href = href
  a.download = nombre
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 1000)
}

export const conciliacionTarjetasApi = {
  listar: () => api.get(base),
  ver: (id) => api.get(`${base}/${id}`),
  conciliar: (liquidadas, pagos) => {
    const fd = new FormData()
    fd.append('liquidadas', liquidadas)
    fd.append('pagos', pagos)
    return api.post(base, fd, { timeout: 300000 })
  },
  subirFtp: (id) => api.post(`${base}/${id}/subir-ftp`),
  verificar: (id) => api.post(`${base}/${id}/verificar`, {}, { timeout: 300000 }),
  bajarArchivo: (id, nombre) => bajar(`${base}/${id}/archivo`, nombre),
  bajarInformePdf: (id, numero) => bajar(`${base}/${id}/informe-pdf`, `conciliacion_tarjetas_${numero || id}.pdf`),
  bajarInforme: (id) => bajar(`${base}/${id}/informe`, `cargos-tarjetas-conciliacion-${id}.csv`),
  bajarSinPareja: (id) => bajar(`${base}/${id}/sin-pareja`, `cupones-sin-pareja-conciliacion-${id}.csv`),
}
